import { createStore } from '@cobuildlab/react-simple-state';

export const drawerSidebarEvent = createStore({
  initialValue: {
    isOpen: false,
  },
});
